import http from "@/utils/request";

const logistics = {
  track: (data) =>
    http.sendRequest({
      METHOD_NAME: "logisticsTrack.yunda",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  subscribe: (data) =>
    http.sendRequest({
      METHOD_NAME: "logisticsSubscribe.yunda",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default logistics;
